<template>
  <div class="text-right">
    <v-dialog
      v-model="dialog"
      max-width="1000"
      content-class="sc-modal sc-modal--lg"
      scrollable
    >
      <template v-if="!externallyControlled" v-slot:activator="{ on, attrs }">
        <slot name="activator" :on="on" :attrs="attrs">
          <v-btn
            icon
            small
            class="bar-cog-btn"
            aria-label="Configurações da produção"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small> mdi-cog </v-icon>
          </v-btn>
        </slot>
      </template>

      <v-card v-if="dialog" flat class="sc-modal__card config-producao-card">
        <!-- Close button (floating) -->
        <v-btn icon class="sc-modal__close" @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <!-- Hero header (bespoke: gradient bg, larger icon padding) -->
        <div class="config-header">
          <v-icon class="config-header-icon" :style="headerIconStyle">mdi-cog</v-icon>
          <div class="config-header-text">
            <span class="config-header-title">Configurações de exibição</span>
            <span class="config-header-subtitle">{{ producao ? ((producao.nome_producao || producao.sig_producao) + ' · ' + producao.sig_producao) : '' }}</span>
          </div>
        </div>

        <!-- Tabs -->
        <v-tabs
          v-model="activeTab"
          background-color="transparent"
          color="primary"
          show-arrows
          slider-size="3"
          class="config-tabs"
        >
          <v-tab v-show="showMosaico" :key="0">
            <v-icon small class="mr-1">mdi-view-grid</v-icon>
            Mosaico
          </v-tab>
          <v-tab v-show="showMosaico" :key="1">
            <v-icon small class="mr-1">mdi-image-multiple</v-icon>
            Descanso
          </v-tab>
          <v-tab v-show="modoModeracao === 'Midias'" :key="2">
            <v-icon small class="mr-1">mdi-account-cancel</v-icon>
            Contas
          </v-tab>
          <v-tab v-show="modoModeracao === 'Midias'" :key="3">
            <v-icon small class="mr-1">mdi-alphabetical-off</v-icon>
            Palavras
          </v-tab>
          <v-tab v-show="modoModeracao === 'Midias'" :key="4">
            <v-icon small class="mr-1">mdi-view-column</v-icon>
            Colunas
          </v-tab>
          <v-tab v-show="showTarja" :key="5">
            <v-icon small class="mr-1">mdi-television</v-icon>
            Tarja
          </v-tab>
          <v-tab v-show="['Midias', 'Noticias'].includes(modoModeracao)" :key="6">
            <v-icon small class="mr-1">mdi-folder</v-icon>
            Pastas
          </v-tab>
          <v-tab v-show="modoModeracao === 'Enquetes'" :key="7">
            <v-icon small class="mr-1">mdi-poll</v-icon>
            Tarja Enquete
          </v-tab>
          <v-tab v-show="modoModeracao === 'Cronometro'" :key="8">
            <v-icon small class="mr-1">mdi-timer</v-icon>
            Tarja Cronômetro
          </v-tab>
          <v-tab v-show="modoModeracao === 'Noticias'" :key="9">
            <v-icon small class="mr-1">mdi-monitor</v-icon>
            Tela de exibição
          </v-tab>
          <v-tab v-show="modoModeracao === 'Midias'" :key="10">
            <v-icon small class="mr-1">mdi-map</v-icon>
            Mapa
          </v-tab>
          <v-tab @click="getProducaoCredenciaisYoutube(codProducao)" v-show="modoModeracao === 'Midias'" :key="11">
            <v-icon small class="mr-1">mdi-youtube</v-icon>
            Youtube
          </v-tab>
          <!-- activeTab is the tab's RENDER INDEX, not this key: v-tab's `value` is a
               computed off to/href in Vuetify 2, so it cannot be set explicitly.
               Every tab is v-show (always rendered), so index === key only while these
               keys stay contiguous from 0 — renumber the rest if you remove one. -->
          <v-tab v-show="showLinks" :key="12">
            <v-icon small class="mr-1">mdi-link-variant</v-icon>
            Links
          </v-tab>
        </v-tabs>

        <!-- Tab content -->
        <div class="config-tab-content">
          <div v-show="activeTab === 0">
            <ConfigTabMosaico :active="activeTab === 0" :cod-producao="codProducao" :sigla-producao="siglaProducao" />
          </div>
          <div v-show="activeTab === 1">
            <ConfigTabTelaDescanso :active="activeTab === 1" :cod-producao="codProducao" />
          </div>
          <div v-show="activeTab === 2">
            <ConfigTabContasBloqueadas :active="activeTab === 2" :cod-producao="codProducao" />
          </div>
          <div v-show="activeTab === 3">
            <ConfigTabPalavrasBloqueadas :active="activeTab === 3" :cod-producao="codProducao" />
          </div>
          <div v-show="activeTab === 4">
            <ConfigTabColunas :active="activeTab === 4" :cod-producao="codProducao" :change-coluna="changeColuna" :num-coluna-telao="num_coluna_telao" />
          </div>
          <div v-show="activeTab === 5">
            <ModalConfiguracaoTarja :producao="producao" />
          </div>
          <div v-show="activeTab === 6">
            <ConfigTabPastas :active="activeTab === 6" :cod-producao="codProducao" />
          </div>
          <div v-show="activeTab === 7" class="tab-panel-body">
            <EditarConfiguracaoTarjaEnquete :cod_producao="codProducao" />
          </div>
          <div v-show="activeTab === 8" class="tab-panel-body">
            <EditarConfiguracaoTarjaCronometro :cod_producao="codProducao" />
          </div>
          <div v-show="activeTab === 9">
            <ConfigTabTelaExibicao :cod-producao="codProducao" :producao="producao" />
          </div>
          <div v-show="activeTab === 10">
            <ConfigTabMapa :cod-producao="codProducao" :producao="producao" />
          </div>
          <div v-show="activeTab === 11">
            <ModalConfigChatYoutube />
          </div>
          <div v-show="activeTab === 12">
            <ModalControleTokenServico :producao="producao" :linkTypes="currentLinkTypes" />
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import EditarConfiguracaoTarjaEnquete from "../Enquetes/EditarConfiguracoesTarjaEnquete.vue";
import EditarConfiguracaoTarjaCronometro from "../Cronometro/EditarConfiguracaoTarjaCronometro.vue";
import ModalConfigChatYoutube from "./ModalConfigChatYoutube.vue";
import ModalControleTokenServico from "./ModalControleTokenServico.vue";
import ModalConfiguracaoTarja from "./ModalConfiguracaoTarja.vue";
import ConfigTabMosaico from "./tabs/ConfigTabMosaico.vue";
import ConfigTabTelaDescanso from "./tabs/ConfigTabTelaDescanso.vue";
import ConfigTabContasBloqueadas from "./tabs/ConfigTabContasBloqueadas.vue";
import ConfigTabPalavrasBloqueadas from "./tabs/ConfigTabPalavrasBloqueadas.vue";
import ConfigTabColunas from "./tabs/ConfigTabColunas.vue";
import ConfigTabPastas from "./tabs/ConfigTabPastas.vue";
import ConfigTabTelaExibicao from "./tabs/ConfigTabTelaExibicao.vue";
import ConfigTabMapa from "./tabs/ConfigTabMapa.vue";

export default {
  name: "ModalConfiguracoesProducao",
  props: {
    producao: Object,
    codProducao: Number,
    siglaProducao: String,
    changeColuna: Function,
    num_coluna_telao: Number,
    modoModeracao: String,
    // Opt-in external control (`:visible.sync`) for callers that open this from
    // a menu entry instead of an activator button. Left undefined, the modal
    // keeps its own activator — unchanged for every existing caller.
    visible: { type: Boolean, default: undefined },
  },
  components: {
    EditarConfiguracaoTarjaEnquete,
    EditarConfiguracaoTarjaCronometro,
    ModalConfigChatYoutube,
    ModalControleTokenServico,
    ModalConfiguracaoTarja,
    ConfigTabMosaico,
    ConfigTabTelaDescanso,
    ConfigTabContasBloqueadas,
    ConfigTabPalavrasBloqueadas,
    ConfigTabColunas,
    ConfigTabPastas,
    ConfigTabTelaExibicao,
    ConfigTabMapa,
  },
  data() {
    return {
      activeTab: null,
      dialog: false,
    };
  },
  mounted() {
    this.activeTab = this.firstVisibleTab;
  },
  computed: {
    externallyControlled() {
      return this.visible !== undefined;
    },
    // Globo Graphics reaches its links through its own preview-link control, so
    // this tab would be a second, divergent copy of the same token.
    showLinks() {
      return this.modoModeracao !== "GloboGraphics";
    },
    headerIconStyle() {
      const isNoticias = this.modoModeracao === "Noticias";
      const color = isNoticias ? "122, 185, 255" : "0, 224, 116";
      return {
        color: isNoticias ? "#7AB9FF" : "var(--v-primary-base)",
        background: `rgba(${color}, 0.15)`,
      };
    },
    showMosaico() {
      return (
        (this.producao && this.producao.settings?.mosaico?.enabled && this.modoModeracao === "Midias") ||
        (this.codProducao && this.modoModeracao === "Cameras")
      );
    },
    showTarja() {
      return (
        this.producao &&
        ((this.producao.settings?.tarja?.enabled && this.modoModeracao === "Midias") ||
          this.modoModeracao === "Cameras")
      );
    },
    firstVisibleTab() {
      if (this.showMosaico) return 0;

      const tabs = [
        { key: 2, show: this.modoModeracao === "Midias" },
        { key: 5, show: this.showTarja },
        { key: 6, show: ["Midias", "Noticias"].includes(this.modoModeracao) },
        { key: 7, show: this.modoModeracao === "Enquetes" },
        { key: 8, show: this.modoModeracao === "Cronometro" },
        { key: 9, show: this.modoModeracao === "Noticias" },
        { key: 10, show: this.modoModeracao === "Midias" },
        { key: 12, show: this.showLinks },
      ];
      const first = tabs.find((t) => t.show);
      return first ? first.key : 12;
    },
    currentLinkTypes() {
      const map = {
        Midias: ["tarja", "mosaico"],
        Noticias: ["noticias"],
        Enquetes: ["enquete"],
        Cameras: ["tarja-cameras"],
        Cronometro: ["tarja"],
      };
      return map[this.modoModeracao] || ["tarja", "mosaico"];
    },
  },
  methods: {
    ...mapActions({
      getProducaoCredenciaisYoutube: "producoes/getProducaoCredenciaisYoutube",
    }),
    close() {
      this.dialog = false;
    },
    open() {
      this.activeTab = this.firstVisibleTab;
    },
  },
  watch: {
    dialog(val) {
      if (val) this.open();
      if (this.externallyControlled) this.$emit("update:visible", val);
    },
    visible(val) {
      this.dialog = Boolean(val);
    },
    "$store.state.producoes.selectedProducao": {
      handler: async function (newProducao) {
        if (!newProducao) return;
        await this.getProducaoCredenciaisYoutube(newProducao.cod_producao);
      },
      deep: false,
      immediate: false,
    },
  },
};
</script>

<style lang="scss">
/* Card height extension — the .sc-modal__card global provides the rest. */
.config-producao-card {
  height: 80vh;
  max-height: 850px;
}

/* Hero header — bespoke: gradient bg + larger icon padding */
.config-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  padding-right: 56px;
  background: linear-gradient(135deg, var(--v-surface_tertiary-base) 0%, var(--v-surface_secondary-base) 100%);
  border-bottom: 1px solid var(--sc-border-subtle);
  flex-shrink: 0;
}

.config-header-icon {
  font-size: 32px !important;
  border-radius: var(--sc-radius-lg);
  padding: 10px;
}

.config-header-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.config-header-title {
  font-size: var(--sc-text-h);
  font-weight: var(--sc-weight-bold);
  color: var(--v-text_primary-base);
}

.config-header-subtitle {
  font-size: var(--sc-text-lg);
  color: var(--v-text_secondary-base);
  text-transform: uppercase;
  letter-spacing: var(--sc-tracking-caps);
}

/* Tabs */
.config-tabs {
  flex-shrink: 0;
  border-bottom: 1px solid var(--sc-border-subtle);
  background: var(--v-surface_secondary-base) !important;

  .v-tab {
    color: var(--v-text_secondary-base) !important;
    font-weight: var(--sc-weight-medium);
    font-size: var(--sc-text-lg);
    text-transform: none;
    letter-spacing: 0;
    min-width: 80px;
    padding: 0 12px;
    transition: color var(--sc-duration-base) var(--sc-easing-standard);

    .v-icon {
      color: inherit !important;
    }

    &--active {
      color: var(--v-primary-base) !important;
      font-weight: var(--sc-weight-bold);
    }
  }

  .v-tabs-slider-wrapper {
    transition: left var(--sc-duration-slow) var(--sc-easing-standard);
  }
}

/* Consistent tab panel padding */
.tab-panel-body {
  padding: 20px 24px;
}

/* Scrollable content area: header ~72px, tabs ~48px */
.config-tab-content {
  height: calc(80vh - 72px - 48px);
  max-height: calc(850px - 72px - 48px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--sc-border-default);
    border-radius: 3px;

    &:hover {
      background: var(--sc-surface-tint-stronger);
    }
  }

  scrollbar-width: thin;
  scrollbar-color: var(--sc-border-default) transparent;
}
</style>
